<template>
  <div class="grants_inner">
    <div class="inner">
      <div class="box">
        <button class="back" @click="back">
          <div class="item">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="27.55"
              height="27.549"
              viewBox="0 0 27.55 27.549"
            >
              <path
                id="Union_2"
                data-name="Union 2"
                d="M1.431,27.2l-.607-.608a2,2,0,0,1,0-2.829l9.751-9.752L.822,4.258a2,2,0,0,1,0-2.829L1.428.823a2,2,0,0,1,2.829,0l9.753,9.753L23.764.823a2,2,0,0,1,2.828,0l.608.608a2,2,0,0,1,0,2.829l-9.753,9.753,9.75,9.75a2,2,0,0,1,0,2.829l-.607.607a2,2,0,0,1-2.829,0l-9.75-9.75L4.26,27.2a2,2,0,0,1-2.829,0Z"
                transform="translate(-0.236 -0.237)"
                fill="#fff"
              />
            </svg>
          </div>
          <div class="item">
            <div class="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14.841"
                height="14"
                viewBox="0 0 14.841 14"
              >
                <g
                  id="Group_5958"
                  data-name="Group 5958"
                  transform="translate(1607.841 4906) rotate(180)"
                >
                  <path
                    id="Icon_ionic-md-arrow-round-back"
                    data-name="Icon ionic-md-arrow-round-back"
                    d="M6.911,11.98h9.025l-3.5-3.349a1.4,1.4,0,0,1,0-1.906,1.247,1.247,0,0,1,1.822,0l5.829,5.651a1.285,1.285,0,0,1,.38.945v.017a1.285,1.285,0,0,1-.38.945l-5.824,5.651a1.247,1.247,0,0,1-1.822,0,1.4,1.4,0,0,1,0-1.906l3.5-3.349H6.916a1.32,1.32,0,0,1-1.291-1.35A1.306,1.306,0,0,1,6.911,11.98Z"
                    transform="translate(1587.375 4885.67)"
                    fill="#db504a"
                  />
                </g>
              </svg>
            </div>
            <p class="f-roman font-21">{{ $fn.tr("Back") }}</p>
          </div>
        </button>
        <div class="top-cont">
          <p class="organization">{{ $fn.tr("grantee_oganization") }}</p>
          <h2 class="f-roman font-21 underline">
            {{ _.get(contentData, "data.list.0.grantee_oganization") }}
          </h2>
        </div>
        <div class="content">
          <div class="item">
            <p class="font-16 f-roman">
              {{ $fn.tr("Project Title:") }} <br /><span
                class="font-16 f-medium"
                >{{ _.get(getData, "title") }}</span
              >
            </p>
          </div>
          <!-- <div class="item">
            <p class="font-16 f-roman">
              {{ $fn.tr("Project ID:") }}
              <span class="font-16 f-medium">{{
                _.get(getData, "project_id")
              }}</span>
            </p>
          </div> -->
          <div class="item">
            <p class="font-16 f-roman">
              {{ $fn.tr("Status:") }}
              <span
                class="font-16 f-medium"
                :class="{ active: _.get(getData, 'status') === 'Active' }"
                >{{ $fn.tr(_.get(getData, "status")) }}</span
              >
            </p>
          </div>
          <div class="item">
            <p class="font-16 f-roman">
              {{ $fn.tr("Project Duration (dd/mm/yy):") }}
              <span class="font-16 f-medium">{{ getDuration }}</span>
            </p>
          </div>
          <div class="item">
            <p class="font-16 f-roman">
              {{ $fn.tr("Budget:") }}
              <span class="font-16 f-medium">{{ getBudget }} ₾</span>
            </p>
          </div>
          <div class="item">
            <p class="font-16 f-roman">
              {{ $fn.tr("Geography:") }}
              <span class="font-16 f-medium">{{
                _.get(getData, "geography")
              }}</span>
            </p>
          </div>
          <div class="item">
            <p class="font-16 f-roman">
              {{ $fn.tr("Area of Work:") }}
              <span class="font-16 f-medium">{{
                _.get(getData, "area_of_work")
              }}</span>
            </p>
          </div>
          <div class="item">
            <p class="font-16 f-roman">
              {{ $fn.tr("Number of Beneficiaries:") }}
              <span class="font-16 f-medium">{{
                _.get(getData, "number_of_beneficiares")
              }}</span>
            </p>
          </div>
          <div class="text-cont">
            <p class="ttl font-16 f-roman">
              {{ $fn.tr("Publication statement:") }}
            </p>
            <div
              class="txt f-roman"
              v-html="_.get(getData, 'publication_statement')"
            ></div>
          </div>
          <div class="export-cont">
            <download-excel :data="getECXELData">
              <button>
                <p class="f-roman font-16">
                  {{ $fn.tr("Export Profile To Excel:") }}
                </p>
                <div class="icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30.653"
                    height="29.664"
                    viewBox="0 0 30.653 29.664"
                  >
                    <path
                      id="Exel"
                      d="M22.944,20v6.922H18v17.8h4.944v4.944H48.653V20Zm0,11.866h2.62L26.9,33.843l1.335-1.978h2.62l-2.62,3.955,2.62,3.955h-2.62L26.9,37.8l-1.335,1.978h-2.62l2.62-3.955ZM46.675,47.686H24.922V44.72H35.8V38.787h7.91V36.81H35.8V34.832h7.91V32.854H35.8V30.877h7.91V28.9H35.8V26.922H24.922V21.978H46.675Z"
                      transform="translate(-18 -20)"
                      fill="#57a773"
                    />
                  </svg>
                </div>
              </button>
            </download-excel>
          </div>
        </div>
      </div>
      <div class="box">
        <GmapMap
          :center="{
            lat: parseFloat(_.get(getMarker[0], 'map.lat')),
            lng: parseFloat(_.get(getMarker[0], 'map.lon'))
          }"
          :zoom="zoomData"
          ref="mapRef"
          :options="{
            styles: darkTheme,
            zoomControl: true,
            gestureHandling: 'cooperative'
          }"
        >
          <GmapMarker
            v-for="(item, index) in getMarker"
            :key="index"
            :icon="marker"
            :position="{
              lat: parseFloat(_.get(item, 'map.lat')),
              lng: parseFloat(_.get(item, 'map.lon'))
            }"
          >
          </GmapMarker>
        </GmapMap>
      </div>
    </div>
  </div>
</template>

<script>
import { gmapApi } from "vue2-google-maps";
export default {
  props: ["contentData"],
  data() {
    return {
      zoomData: 8,
      marker: "https://d.radikal.ru/d07/2110/74/ad40fa0d2bb9.png",
      darkTheme: [
        { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
        { elementType: "labels.text.stroke", stylers: [{ color: "#242f3e" }] },
        { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
        {
          featureType: "administrative.locality",
          elementType: "labels.text.fill",
          stylers: [{ color: "#d59563" }]
        },
        {
          featureType: "poi",
          elementType: "labels.text.fill",
          stylers: [{ color: "#d59563" }]
        },
        {
          featureType: "poi.park",
          elementType: "geometry",
          stylers: [{ color: "#263c3f" }]
        },
        {
          featureType: "poi.park",
          elementType: "labels.text.fill",
          stylers: [{ color: "#6b9a76" }]
        },
        {
          featureType: "road",
          elementType: "geometry",
          stylers: [{ color: "#38414e" }]
        },
        {
          featureType: "road",
          elementType: "geometry.stroke",
          stylers: [{ color: "#212a37" }]
        },
        {
          featureType: "road",
          elementType: "labels.text.fill",
          stylers: [{ color: "#9ca5b3" }]
        },
        {
          featureType: "road.highway",
          elementType: "geometry",
          stylers: [{ color: "#746855" }]
        },
        {
          featureType: "road.highway",
          elementType: "geometry.stroke",
          stylers: [{ color: "#1f2835" }]
        },
        {
          featureType: "road.highway",
          elementType: "labels.text.fill",
          stylers: [{ color: "#f3d19c" }]
        },
        {
          featureType: "transit",
          elementType: "geometry",
          stylers: [{ color: "#2f3948" }]
        },
        {
          featureType: "transit.station",
          elementType: "labels.text.fill",
          stylers: [{ color: "#d59563" }]
        },
        {
          featureType: "water",
          elementType: "geometry",
          stylers: [{ color: "#17263c" }]
        },
        {
          featureType: "water",
          elementType: "labels.text.fill",
          stylers: [{ color: "#515c6d" }]
        },
        {
          featureType: "water",
          elementType: "labels.text.stroke",
          stylers: [{ color: "#17263c" }]
        }
      ]
    };
  },
  methods: {
    back() {
      if (this.$route.fullPath?.includes("singleview")) {
        if (this.$route.params.path2 == "singleview") {
          this.$router.push(
            `/${_.get(this.$store.state.main, "indx.locale")}/${
              this.$route.params.path1
            }`
          );
        } else {
          this.$router.push(
            `/${_.get(this.$store.state.main, "indx.locale")}/${
              this.$route.params.path1
            }/${this.$route.params.path2}`
          );
        }
      }
    }
  },
  computed: {
    getData() {
      return _.get(this.contentData, "data.list.0");
    },
    getOrganization() {
      return _.get(this.getINDX, "organization").find(
        el => el.id === _.get(this.getData, "organization.0")
      );
    },
    getECXELData() {
      var data = this.getData;
      var res;

      res = [
        {
          Grantee_Organization: _.get(data, "grantee_oganization"),
          Project_title: _.get(data, "title"),
          Project_ID: _.get(data, "id"),
          status: _.get(data, "status"),
          Project_Duration: `${_.get(data, "project_duration")}/${_.get(
            data,
            "project_duration_to"
          )}`,
          Budget: `${_.get(data, "budget")} GEL`,
          Geogtaphy: _.get(data, "geography"),
          Area_of_Work: _.get(data, "area_of_work"),
          Number_of_Beneficiares: _.get(data, "number_of_beneficiares"),
          Publication_Statement: _.get(data, "publication_statement")
        }
      ];
      return res;
    },
    getINDX() {
      return this.$store.state.main.indx.terms;
    },
    getMarker() {
      // return _.get(this.getINDX, "region").find(
      //   el => _.get(el, "id") === _.get(this.getData, "region.0")
      // );
      var arr = [];
      _.get(this.getINDX, "region").forEach(item => {
        if (
          _.includes(
            _.get(this.contentData, "data.list.0.region"),
            _.get(item, "id")
          )
        ) {
          arr.push(item);
        }
      });
      return arr;
    },
    getBudget() {
      var data = _.get(this.getData, "budget");
      data = parseFloat(data);
      var res = new Intl.NumberFormat().format(data);
      return res;
    },
    getDuration() {
      var data = [
        _.get(this.getData, "project_duration"),
        _.get(this.getData, "project_duration_to")
      ];
      if (data !== undefined) {
        for (var i = 0; i < data.length; i++) {
          if (data[i] !== undefined) {
            data[i] = data[i].replace("-", "/");
            data[i] = data[i].replace("-", "/");
          }
        }
        data = data.join(" - ");
        return data;
      }
    }
  }
};
</script>

<style lang="scss">
body.black {
  .inner .box:nth-child(1) .back .item:nth-child(1) {
    path {
      fill: black !important;
    }
  }
}
.grants_inner {
  .txt {
    color: var(--bonus-txt);
  }
  .content::-webkit-scrollbar {
    width: 5px;
  }

  .content::-webkit-scrollbar-track {
    background-color: #dfdfdf;
    width: 2px;
  }

  .content::-webkit-scrollbar-thumb {
    border-radius: 50px;
    background-color: #57a773;
  }
  background: var(--thirdy-tranparent);
  .inner {
    display: flex;
    @media (max-width: 1023px) {
      flex-direction: column;
    }
    .box {
      width: 50%;
      @media (max-width: 1023px) {
        width: 100%;
      }
      &:nth-child(1) {
        .content {
          height: 750px;
          overflow: auto;
          @media (max-width: 1023px) {
            height: unset;
            overflow: unset;
          }
        }
        .back {
          cursor: pointer;
          position: absolute;
          top: 40px;
          right: -168px;
          z-index: 9;
          width: 250px;
          display: flex;
          height: 80px;
          @media (max-width: 1023px) {
            display: none;
          }
          .item {
            width: 50%;
            height: 100%;
            &:nth-child(1) {
              display: flex;
              justify-content: center;
              align-items: center;
              background-color: var(--bonus-txt);
              flex: 1;
              path {
                fill: white !important;
              }
            }
            &:nth-child(2) {
              display: flex;
              justify-content: center;
              align-items: center;
              background: var(--white-bg);
              flex: 2;
              p {
                color: var(--bonus-txt);
              }
              .icon {
                margin-right: 24px;
              }
            }
          }
        }
        position: relative;
        padding: 70px 37.5px 2px 30px;
        // @media (max-width: 1023px) {
        //   padding-top: 100px;
        // }
        .export-cont {
          margin-bottom: 30px;
          margin-top: 30px;
          display: flex;
          justify-content: flex-end;
          button {
            cursor: pointer;
            background: none;
            display: flex;
            justify-content: center;
            align-items: center;
            color: var(--bonus-txt);
            p {
              margin-right: 10px;
            }
          }
        }
        .text-cont {
          margin-top: 17px;
          .ttl {
            color: var(--primary-txt);
            margin-bottom: 35px;
          }
        }
        .content {
          margin-top: 16px;
          border-top: 1px solid #c8c9ca;
          padding-right: 20px;
          .item {
            padding-top: 20px;
            padding-bottom: 20px;
            border-bottom: 1px solid #c8c9ca;
            p {
              color: var(--primary-txt);
              span {
                color: var(--bonus-txt);
                &.active {
                  color: #57a773;
                }
              }
            }
          }
        }
        .top-cont {
          .organization {
            color: var(--primary-txt);
          }
          h2 {
            color: var(--bonus-txt);
            margin-top: 6px;
            padding-right: 40px;
          }
        }
      }
      &:nth-child(2) {
        @media (max-width: 1023px) {
          height: 700px;
        }
        div {
          transition: none;
        }
        position: relative;
        .vue-map-container {
          width: 100%;
          height: 100%;
          button {
            display: none;
          }
          .gmnoprint {
            display: none;
          }
        }
      }
    }
  }
}
</style>
